/**
 * GA4 + GTM are now bootstrapped directly inside `public/index.html` so they
 * fire as early as possible (Phase 6.2). This component is kept as a no-op
 * shim so existing imports don't break — and so we have a single place to
 * manage Consent Mode lifecycle if we ever decide to move the bootstrap back
 * into React.
 *
 * For event tracking, use `lib/analytics.js → trackEvent(name, params)`.
 */
export default function Analytics() {
  return null;
}
